import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { QrcodeOutlined } from "@ant-design/icons";
import { createRoot } from "react-dom/client";
import { Tooltip } from "antd";
import config from "../../../config.js";

const QRCodeGenerator = ({ name, id, type}) => {
  const originalUrl = `${config.qrUrl}/${type}/${id}`;
  const baseRedirectUrl = `${config.qrUrl}/qrRedirect`;

  const handleGenerateAndDownload = () => {
    const redirectUrl = `${baseRedirectUrl}?data=${encodeURIComponent(
      btoa(originalUrl)
    )}`;

    // Step 1: Create a temporary container
    const tempContainer = document.createElement("div");
    document.body.appendChild(tempContainer);

    // Step 2: Create the QR code with a callback to access the canvas
    const QRTemp = () => {
      const qrRef = React.useRef();

      React.useEffect(() => {
        const canvas = qrRef.current?.querySelector("canvas");
        if (canvas) {
          const imageUrl = canvas.toDataURL("image/png");
          const link = document.createElement("a");
          link.href = imageUrl;
          link.download = `${name}_${id}.png`;
          link.click();

          // Clean up after download
          setTimeout(() => {
            root.unmount();
            document.body.removeChild(tempContainer);
          }, 100);
        }
      }, []);

      return (
        <div
          ref={qrRef}
          style={{ position: "absolute", top: "-9999px", left: "-9999px" }}
        >
          <QRCodeCanvas value={redirectUrl} size={256} />
        </div>
      );
    };

    const root = createRoot(tempContainer);
    root.render(<QRTemp />);
  };

  return (
    <Tooltip title="QR Download">
      <QrcodeOutlined
        className="shadow"
        style={{ fontSize: 22, color: "#46604A", cursor: "pointer" }}
        onClick={handleGenerateAndDownload}
      />
    </Tooltip>
  );
};

export default QRCodeGenerator;
